import { mockBoardingApplicationJson } from '../sharedBoarding/mockBoardingApplicationJson';
import {
  createMockFileList,
  staticMpaFilesMap
} from '../sharedBoarding/mockBoardingApplicationFiles';
import { defaultMockMpaIds, staticMpas } from '../sharedBoarding/mockBoardingApplicationMpaList';
import { getMockValue } from '../_mockDataHelpers';
import { sharedFormFields } from '../../_formFields';

export const createMockMpaDetail = (guid, _options) => {
  const isDefaultMockMpaId = defaultMockMpaIds.includes(`${guid}`);
  const mockMpaId =
    typeof guid === 'string' && (isDefaultMockMpaId || `${Number(guid)}` !== 'NaN')
      ? Number(guid)
      : guid;
  const mockMpa = mockBoardingApplicationJson(mockMpaId);
  const mockAppDetails = {
    employeeOnlyMpaMetadata: {
      policyException: {
        description: getMockValue({ type: 'description', length: 'long' })
      },
      riskExposureInputs: mockRiskExposureInputs()
    },
    mpaDetails: {
      applicationMpaId: `${guid}`,
      dbaName: mockMpa.businessInformation.dbaName,
      mpa: mockMpa,
      fileList: createMockFileList({ staticFiles: staticMpaFilesMap[mockMpaId] || [] }),
      ...(staticMpas && staticMpas[mockMpaId] && { ...staticMpas[mockMpaId] })
    }
  };
  return mockAppDetails;
};

export const mockCrabApplicationMpaDetailGet = (body, params, options) => {
  const { guid = '' } = options || {};
  const mockDetails = createMockMpaDetail(guid, options);
  return { [guid]: mockDetails };
};

export const mockRiskExposureInputs = () => ({
  creditReturnRatio: getMockValue({ type: 'ratio' }),
  chargebackRatio: getMockValue({ type: 'ratio' }),
  nonDeliveryRiskDays: getMockValue({ type: 'number' }),
  creditTime: getMockValue({ type: 'number' }),
  monthlyVolume: getMockValue({ type: 'number' }),
  percentKeyed: getMockValue({ type: 'ratio' }),
  mccCode: getMockValue({ type: 'list', list: sharedFormFields.mccCode.list })
});

export default mockCrabApplicationMpaDetailGet;
